import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "image-list" }

import { UploadOutlined } from "@ant-design/icons-vue";
import { FileService } from "@/api/services/FileService";
import { message } from "ant-design-vue";
import { UploadRequestOption } from "ant-design-vue/lib/vc-upload/interface";
import { ref, watch } from "vue";
import { ToImage } from "@/utils/image";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilesUpload',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const fileList = ref<Array<string>>(props.modelValue || []);

// 处理文件上传
const handleRequest = async (option: UploadRequestOption) => {
  const res = await FileService.Upload({ file: option.file as Blob });
  if (res.code === 0) {
    message.success("上传成功");
    fileList.value.push(res.data);
    emit("update:modelValue", fileList.value);
  } else {
    message.error(res.msg);
  }
};

// 处理上传状态变化
const handleChange = (info: any) => {
  if (info.file.status === "done") {
    message.success(`${info.file.name} 上传成功`);
  } else if (info.file.status === "error") {
    message.error(`${info.file.name} 上传失败`);
  }
};

// 删除图片
const removeImage = (index: number) => {
  fileList.value.splice(index, 1);
  emit("update:modelValue", fileList.value);
};

// 监听 modelValue 的变化
watch(
  () => props.modelValue,
  (newVal) => {
    fileList.value = newVal;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      customRequest: handleRequest,
      "show-upload-list": false,
      multiple: true,
      onChange: handleChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, null, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadOutlined)),
            _cache[0] || (_cache[0] = _createTextVNode(" 上传文件 "))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (url, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: url,
          class: "image-item"
        }, [
          _createVNode(_component_a_image, {
            src: _unref(ToImage)(url),
            alt: "Uploaded Image",
            class: "uploaded-image",
            width: 170
          }, null, 8, ["src"]),
          _createVNode(_component_a_button, {
            type: "primary",
            danger: "",
            onClick: ($event: any) => (removeImage(index)),
            class: "delete-button"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 删除 ")
            ])),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}
}

})